module.exports = __webpack_public_path__ + "img/18.983c1999.jpg";